var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.209,
    height: 38.055,
    viewBox: "0 0 26.209 38.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5797",
    "data-name": "Group 5797",
    transform: "translate(-66.563 -618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M19212.777,10469.727h0l-13.105-7.565v-15.131l13.105-7.566,13.1,7.566v15.131l-13.1,7.565Zm0-26.942-7.629,4.405V10456l7.629,4.4,7.623-4.4v-8.811Z",
    transform: "translate(-19133.109 -9813.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_341",
    "data-name": "Polygon 341",
    transform: "translate(84 643) rotate(-180)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.401965141296387 24.5 L 0.5980343818664551 24.5 L 4.5 2.822413444519043 L 8.401965141296387 24.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.5 5.644817352294922 L 1.196066856384277 24 L 7.803933143615723 24 L 4.5 5.644817352294922 M 4.5 0 L 9 25 L 0 25 L 4.5 0 Z",
    stroke: "none",
    fill: "#3b3b3b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/sites.fe96c8689dde34ab673c378531c46b0f.svg";
export { ForwardRef as ReactComponent };